import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Services } from './components/Services';
import { HappyPatients } from './components/HappyPatients';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { CTABanner } from './components/CTABanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-bg selection:bg-primary selection:text-text" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Services data-id="element-5" />
        <HappyPatients data-id="element-6" />
        <Team data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CTABanner data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}